import { createSlice } from '@reduxjs/toolkit';
import { createMatcher } from '~/utils/create-action/create-matcher';
import { defaultState } from './data/AccessGroupsAssetsPatchState';
import AccessGroupsAssetsConstants from './constants';

const slice = createSlice({
  name: 'access-groups-assets',
  initialState: defaultState,
  reducers: {
    resetProgress: (state) => {
      state.isLoading = false;
      state.isCompleted = false;
    },
    resetResults: (state) => {
      state.errors = [];
      state.successDeletedAssetsIds = [];
      state.successAddedAssetsIds = [];
      state.pendingAddAssetsIds = [];
      state.pendingDeleteAssetsIds = [];
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      createMatcher([
        AccessGroupsAssetsConstants.PATCH_ACCESS_GROUPS_ASSETS_INIT,
      ]),
      (state, action) => {
        if (!state.isLoading) {
          state.pendingAddAssetsIds = action.payload.assetsToBeAdded;
          state.pendingDeleteAssetsIds = action.payload.assetsToBeDeleted;
          state.successDeletedAssetsIds = [];
          state.successAddedAssetsIds = [];
          state.failedLastAccessGroupAssetsIds = [];
          state.errors = [];
        }
        state.isLoading = true;
        state.isCompleted = false;
      }
    );
    builder.addMatcher(
      createMatcher([
        AccessGroupsAssetsConstants.PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ERROR,
      ]),
      (state, action) => {
        if (action.errors instanceof Array && action.errors.length > 0) {
          action.errors.forEach((error) => state.errors.push(error));
        } else if (action.error) {
          state.errors.push(action.error);
        }
      }
    );
    builder.addMatcher(
      createMatcher([
        AccessGroupsAssetsConstants.PATCH_ACCESS_GROUPS_ASSETS_REQUEST_SUCCESS,
      ]),
      (state, action) => {
        state.isCompleted = true;
        state.isLoading = false;
        state.failedLastAccessGroupAssetsIds =
          action.payload.failedLastAccessGroup;
      }
    );
    builder.addMatcher(
      createMatcher([
        AccessGroupsAssetsConstants.PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ASSETS_ADDED,
      ]),
      (state, action) => {
        action.payload.forEach((assetId) =>
          state.successAddedAssetsIds.push(assetId)
        );
      }
    );
    builder.addMatcher(
      createMatcher([
        AccessGroupsAssetsConstants.PATCH_ACCESS_GROUPS_ASSETS_REQUEST_ASSETS_DELETED,
      ]),
      (state, action) => {
        action.payload.forEach((assetId) =>
          state.successDeletedAssetsIds.push(assetId)
        );
      }
    );
    builder.addMatcher(
      createMatcher([
        AccessGroupsAssetsConstants.PATCH_ACCESS_GROUPS_ASSETS_RESPONSE,
      ]),
      (state, action) => {
        // Just another response received, decrease totals
        const payload = action.payload.payload;
        if (state.isLoading) {
          state.pendingAddAssetsIds = state.pendingAddAssetsIds.filter(
            (assetId) => !payload.assetsToBeAdded.includes(assetId)
          );
          state.pendingDeleteAssetsIds = state.pendingDeleteAssetsIds.filter(
            (assetId) => !payload.assetsToBeDeleted.includes(assetId)
          );
        }
      }
    );
  },
});

export const { resetProgress, resetResults } = slice.actions;
export default slice.reducer;
